/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_3Inputs */

const da_privacy_purpose_3 = /** @type {(inputs: Privacy_Purpose_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bogføring af betalinger: retlig forpligtelse efter bogføringsloven (art. 6, stk. 1, litra c).`)
};

/** @type {(inputs: Privacy_Purpose_3Inputs) => LocalizedString} */
const en_privacy_purpose_3 = da_privacy_purpose_3;

/**

* @param {Privacy_Purpose_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_3 = /** @type {((inputs?: Privacy_Purpose_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_3(inputs)
	return /** @type {LocalizedString} */ ("Bogføring af betalinger: retlig forpligtelse efter bogføringsloven (art. 6, stk. 1, litra c).")
});